import { useState } from "react";
import { post } from "../networking/RequestService";

const useOlanakEkle = () => {
    const [olanak, setOlanak] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const olanakEkle = async (dealData) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post(dealData);
            const profile = res.data.profil;
            if (profile?.olanak) {
                profile.inhouseInquiries = profile.olanak
                    .filter((item) => item.activityType === "In-house Inquiry")
                    .map((item) => ({
                        label: item.activityName,
                        value: item.activityId,
                    }));
            }

            setOlanak(profile);
            return res;
        } catch (err) {
            setError(err);
            setOlanak(null);
            return err;
        } finally {
            setLoading(false);
        }
    };

    return { olanak, loading, error, olanakEkle };
};

export default useOlanakEkle;
